import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ActivityLog from '../ActivityLog';
import * as Common from '../Common';
import Dialog from '../Dialog';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from './../Picklist';
import AsyncSelect from 'react-select/async';
import $ from "jquery";

const Master_risk_configuration = () => {

    const navigate = useNavigate();
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [riskConfigurationData, setRiskConfigurationData] = useState([]);

    const [riskType, setRiskType] = useState("PP");
    const [riskPurpose, setRiskPurpose] = useState(null);
    const [purposeCode, setPurposeCode] = useState(0);
    const [riskResident, setRiskResident] = useState(1);
    const [residentOptions, setResidentOptions] = useState([]);
    const [riskMediumAmount, setRiskMediumAmount] = useState("");
    const [riskHighAmount, setRiskHighAmount] = useState("");


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'RISK_CONFIGURATION'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/'); // no query right
                }
            });
            Common.callApi(Common.apiResidentialStatus, [sid, "listResidential"], result => {
                setResidentOptions(JSON.parse(result));
            });
            Common.callApi(Common.apiRiskConfiguration, [sid, 'listData'], (result) => {
                let resp = JSON.parse(result);
                setRiskConfigurationData(resp);
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handlePurposeChange = (value) => {
        setRiskPurpose(value);
        const purpose = value.id.split('^');
        setPurposeCode(purpose[1]);
    }

    const addRiskConfigurationData = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (riskMediumAmount === "" || riskHighAmount === "") {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (riskMediumAmount === "" ? "Medium Amount." : '');
            msg[i++] = (riskHighAmount === "" ? "High Amount." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (riskHighAmount * 1 < riskMediumAmount * 1) {
            $(".loader").hide();
            setMsgText("High Risk Amount should be greater than equal to Medium Risk Amount.");
            setMsgBox(true);
        } else {
            const obj = {
                type: riskType,
                purpose: purposeCode,
                residentialStatus: riskResident,
                mediumAmount: riskMediumAmount,
                highAmount: riskHighAmount,
            }
            Common.callApi(Common.apiRiskConfiguration, [sid, 'addRiskConfiguration', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setRiskConfigurationData(resp);
                setRiskType("PP");
                setRiskPurpose(null);
                setRiskResident(1);
                setRiskMediumAmount("");
                setRiskHighAmount("");
            });
        }
    }

    const deleteRiskConfigurationData = (id) => {
        Common.callApi(Common.apiRiskConfiguration, [sid, 'deleteRiskData', id], (result) => {
            let resp = JSON.parse(result);
            setRiskConfigurationData(resp);
        });
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Risk Configuration</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Type<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={riskType} onChange={e => setRiskType(e.target.value)}
                                required>
                                <option value="PP">PP</option>
                                <option value="SP">SP</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {
                        riskType === 'SP' ?
                            <>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Purpose</Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={riskPurpose}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchPurposePicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handlePurposeChange}
                                        // isDisabled={scrMode === "Q"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                            </> : null
                    }
                    <Col className="col-md-3 col-6">
                        <Form.Group>
                            <Form.Label>Residential Status<span className="colorThemeRed">*</span></Form.Label>
                            <Form.Select
                                value={riskResident} onChange={e => setRiskResident(e.target.value)}>
                                {
                                    residentOptions.map((item, index) => (
                                        <option value={item.mrs_srno} key={index}>{item.mrs_resident}</option>
                                    ))
                                }
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className="col-md-3 col-6">
                        <Form.Group>
                            <Form.Label>Medium Risk Amount<span className="mandatory text-danger">*</span></Form.Label>
                            <Form.Control type="text" placeholder="Medium Risk Amount" maxLength={50}
                                value={riskMediumAmount}
                                onChange={(e) => Common.validateNumValue(e.target.value, setRiskMediumAmount)}
                                autoComplete="off"
                            />
                        </Form.Group>
                    </Col>
                    {
                        riskType !== 'SP' &&
                        <>
                            <Col className="col-md-3 col-6">
                                <Form.Group>
                                    <Form.Label>High Risk Amount<span className="mandatory text-danger">*</span></Form.Label>
                                    <Form.Control type="text" placeholder="High Risk Amount" maxLength={50}
                                        value={riskHighAmount}
                                        onChange={(e) => Common.validateNumValue(e.target.value, setRiskHighAmount)}
                                        autoComplete="off"
                                    />
                                </Form.Group>
                            </Col>
                        </>
                    }
                </Row>
                <Row>
                    {
                        riskType === 'SP' &&
                        <>
                            <Col className="col-md-3 col-6">
                                <Form.Group>
                                    <Form.Label>High Risk Amount<span className="mandatory text-danger">*</span></Form.Label>
                                    <Form.Control type="text" placeholder="High Risk Amount" maxLength={50}
                                        value={riskHighAmount}
                                        onChange={(e) => Common.validateNumValue(e.target.value, setRiskHighAmount)}
                                        autoComplete="off"
                                    />
                                </Form.Group>
                            </Col>
                        </>
                    }
                    <Col style={{ marginTop: '33px' }}>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => addRiskConfigurationData()}>Add</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                {
                    riskConfigurationData.length > 0 ?
                        <>
                            <Row>
                                <Col>
                                    <Table responsive striped bordered hover>
                                        <thead>
                                            <tr>
                                                {userRight.edit === "1" ? <th></th> : null}
                                                <th className="textRight">Sr No</th>
                                                <th>Type</th>
                                                <th>Purpose</th>
                                                <th>Residential Status</th>
                                                <th>Medium Amount</th>
                                                <th>High Amount</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {riskConfigurationData.map((res) =>
                                                <tr key={res.mrc_srno}>
                                                    {userRight.delete === "1" ?
                                                        <td className="textCenter" >
                                                            <span className="handCursor" onClick={() => deleteRiskConfigurationData(res.mrc_srno)}>
                                                                <div className="colorThemeBlue"><FontAwesomeIcon icon={faTrash} /></div>
                                                            </span>
                                                        </td>
                                                        : null
                                                    }
                                                    <td className="textRight">{res.mrc_srno}</td>
                                                    <td>{res.mrc_type}</td>
                                                    <td>{res.mrc_purpose}</td>
                                                    <td>{res.mrc_residential_status}</td>
                                                    <td>{res.mrc_medium_amount}</td>
                                                    <td>{res.mrc_high_amount}</td>
                                                    <td>{res.mrc_status == 1 ? "Active" : "Inactive"}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </> : null
                }
            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
        </>
    )
}

export default Master_risk_configuration
